import React, { useState } from 'react';
import {useEffect} from 'react';
import {HoraSeleccionar} from './HoraSeleccionar';

// import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';

import DatePicker, { setDefaultLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

import axios from 'axios';

import logo_sharecare1 from '../../assets/logo_sharecare1.png';

import { Modal, Button, ProgressBar } from 'react-bootstrap';


import FormularioPago from '../FormularioPago/FormularioPago';
import {loadStripe} from '@stripe/stripe-js';
import {Elements} from '@stripe/react-stripe-js';
import getPublishableKey from '../../stripe/publishableKey';
import { use } from 'react';
import { useSessionStore } from '../../hooks/useSessionStore';
import { UsuarioContext } from '../../contexts/UsuarioContext';

const stripe_publishable_key = getPublishableKey();

export const ModalAnadirServicioSC = (props) => {
	const {
		ModalAnadirServicioShareCare,
		setModalAnadirServicioShareCare,
		Servicio,
		activeStep,
		MyDate,
		setMyDate,
		addMonths,
		generarListaDias,
		ListaHoras,
		EstadoConsulta,
		ModalSeleccionHora,
		setModalSeleccionHora,
		ModalSeleccionPaciente,
		setModalSeleccionPaciente,
		setActiveStep,
		ExampleCustomInput,
		changeHora,
		ListaPacientes,
		Paciente,
		seleccionarPaciente,
		modHoraModal,
		steps,
		isStepSkipped,
		anadiServicioLista,
		getHoras,
		enviarYMostrarResultado,
		hayHora,
		getHorasShareCare,
		empresa,
		createPayment,
		get_clientSecret,
		clientSecret,
		stripeMessage,
		factura,
		metodoPago,
		setMetodoPago,
		saldo,
		paymentIntent
	} = props;

	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);
	const [ModalCancelarCompra, setModalCancelarCompra] = useState(false)
	const [stripePromise, setStripePromise] = useState('')
	const [saldoMessage, setSaldoMessage] = useState();

	useEffect(()=>{
		let promise = loadStripe(stripe_publishable_key);
		setStripePromise(promise)
	},[stripe_publishable_key])

	const options = {
		clientSecret,
		paymentMethodCreation: 'manual',
	};
	// if (activeStep === 4) {
	// 	document.getElementById('disable-button').style.display = 'none';
	// } else {
	// 	if (activeStep > 0) {
	// 		document.getElementById('disable-button').style.display = 'grid';
	// 	}
	// }

	/**
     * Llamar a una funcion que llame la lista de pacientes y calcule la distancia
     * 
    useEffect(() => {
        getRangoEmpresaPacientes();
    }, []);
    */

	const [habilitado, setHabilitado] = useState(true)

	const getHora = () => {
		let horaSel;
		ListaHoras.forEach((hora) => {
			if (hora.estado == true) {
				horaSel = hora;
			}
		});
		return horaSel;
	};

	const getClase = (paciente) => {
		let distancia = distance(
			paciente.lat,
			paciente.lon,
			empresa.sede.lat,
			empresa.sede.lng,
			'K'
		);
		if (distancia > empresa.sede.radio / 1000 && Servicio.domicilio) {
			return (
				<div className='seleccionPacienteModal-Disable'>
					<div className='fotoSeleccionPacienteModal centrador'>
						<img src={paciente?.fotoPaciente || 'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.omgtb.com%2Fwp-content%2Fuploads%2F2021%2F04%2F620_NC4xNjE-768x768.jpg&f=1&nofb=1&ipt=6e70641a1d064ed7a25e8f5428a004d5f8b720a9ae21a2028f48a538530174b2&ipo=images'} 
							alt={`${paciente?.nombrePaciente} ${paciente?.apellidosPaciente}` }/>
					</div>
					<div className='nombreSeleccionPacienteModal centrador'>
						<div>
							{paciente.nombrePaciente} {paciente.apellidosPaciente}
						</div>
						<div>{paciente.direccionPaciente}</div>
					</div>
				</div>
			);
		}
		if (paciente.id == Paciente.id) {
			return (
				<div
					className={'seleccionPacienteModal-Active'}
					onClick={() => seleccionarPaciente(paciente.id)}
				>
					<div className='fotoSeleccionPacienteModal centrador'>
						<img src={paciente?.fotoPaciente || 'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.omgtb.com%2Fwp-content%2Fuploads%2F2021%2F04%2F620_NC4xNjE-768x768.jpg&f=1&nofb=1&ipt=6e70641a1d064ed7a25e8f5428a004d5f8b720a9ae21a2028f48a538530174b2&ipo=images'} 
							alt={`${paciente?.nombrePaciente} ${paciente?.apellidosPaciente}` }/>
					</div>
					<div className='nombreSeleccionPacienteModal centrador'>
						<div>
							{paciente.nombrePaciente} {paciente.apellidosPaciente}
						</div>
						<div>{paciente.direccionPaciente}</div>
					</div>
				</div>
			);
		} else {
			return (
				<div
					className={'seleccionPacienteModal'}
					onClick={() => seleccionarPaciente(paciente.id)}
				>
					<div className='fotoSeleccionPacienteModal centrador'>
						<img src={paciente?.fotoPaciente || 'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.omgtb.com%2Fwp-content%2Fuploads%2F2021%2F04%2F620_NC4xNjE-768x768.jpg&f=1&nofb=1&ipt=6e70641a1d064ed7a25e8f5428a004d5f8b720a9ae21a2028f48a538530174b2&ipo=images'} 
							alt={`${paciente?.nombrePaciente} ${paciente?.apellidosPaciente}` }/>
					</div>
					<div className='nombreSeleccionPacienteModal centrador'>
						<div>
							{paciente.nombrePaciente} {paciente.apellidosPaciente}
						</div>
						<div>{paciente.direccionPaciente}</div>
					</div>
				</div>
			);
		}
	};

	function distance(lat1, lon1, lat2, lon2, unit) {
		if (lat1 == lat2 && lon1 == lon2) {
			return 0;
		} else {
			var radlat1 = (Math.PI * lat1) / 180;
			var radlat2 = (Math.PI * lat2) / 180;
			var theta = lon1 - lon2;
			var radtheta = (Math.PI * theta) / 180;
			var dist =
				Math.sin(radlat1) * Math.sin(radlat2) +
				Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
			if (dist > 1) {
				dist = 1;
			}
			dist = Math.acos(dist);
			dist = (dist * 180) / Math.PI;
			dist = dist * 60 * 1.1515;
			if (unit == 'K') {
				dist = dist * 1.609344;
			}
			if (unit == 'N') {
				dist = dist * 0.8684;
			}
			return dist;
		}
	}

	const seleccionarMetodoPago = (metodo) => {
		setMetodoPago(metodo);
		if (metodo === 1) {
			setHabilitado(true);
			if(Servicio.precioMin > saldo) {
				setSaldoMessage(`Saldo insuficiente en el monedero.`);
			}else{
				
			}
		} else {
			setSaldoMessage();
			setHabilitado(false);
		}
	}

	const pagoMonedero = async () => {
		if (metodoPago === 1) {
			if (saldo < Servicio.precioMin) {
				setSaldoMessage(`Saldo insuficiente en el monedero.`);
				return;
			} else {
				setSaldoMessage();
			}
			try {
				const response = await axios({
					method: 'POST',
					url: window.ipdirection + 'createPayment-monedero/',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${Usuario.access}`
					},
					data: {
						empresa_id: empresa.datos.id,
						paymentIntent: paymentIntent,
						precio: Servicio.precioMin,
				}
				});
				if (response.data.success) {
					const res = await axios({
						method: 'POST',
						url: window.ipdirection + 'pagoMonedero/',
						headers: {
							'Content-Type': 'application/json',
							'Authorization': `Bearer ${Usuario.access}`	
						},
						data: {
							paciente_id: Paciente.id,
							precio: Servicio.precioMin,
						}
					})

					if (res.status === 200) {
						await enviarYMostrarResultado();
						setActiveStep(activeStep + 1);
					}
				} else {
					throw new Error(response.data.message);
				}
			} catch (error) {
				console.error('Error al procesar el pago:', error);
			}
		}
	}
	//const getHoraSeleccionada = () => ListaHoras.find(h => h.estado);

	const renderStepContent = () => {
		switch (activeStep) {
			case 0:
				return (
					<div>
						{ListaPacientes.map(paciente => (
							<div
								className={`d-flex align-items-center p-2 rounded border my-3 ${Paciente?.id === paciente.id ? 'bg-light border-success' : 'bg-white'}`}
								key={paciente.id}
								style={{ cursor: 'pointer' }}
								onClick={() => seleccionarPaciente(paciente.id)}
							>
								<img
									src={paciente?.fotoPaciente || 'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.omgtb.com%2Fwp-content%2Fuploads%2F2021%2F04%2F620_NC4xNjE-768x768.jpg&f=1&nofb=1&ipt=6e70641a1d064ed7a25e8f5428a004d5f8b720a9ae21a2028f48a538530174b2&ipo=images'} 
									alt="foto"
									className="rounded-circle me-3"
									style={{ width: '40px', height: '40px', objectFit: 'cover' }}
								/>
								<div className="flex-grow-1">
									<div className="fw-semibold text-truncate">{paciente.nombrePaciente} {paciente.apellidosPaciente}</div>
									<small className="text-muted d-block text-truncate">{paciente.direccionPaciente}</small>
								</div>
							</div>
						))}
					</div>
				);
			case 1:
				return (
					<div className="d-flex justify-content-center my-3">
						<DatePicker
							selected={MyDate}
							onChange={date => setMyDate(date)}
							locale='es'
							minDate={new Date()}
							maxDate={addMonths(new Date(), 12)}
							excludeDates={generarListaDias()}
							inline
						/>
					</div>
				);
			case 2:
				return (
					<div className="d-flex flex-wrap gap-2 justify-content-center my-3">
						{ListaHoras.map((hora) => {
							return (
								<HoraSeleccionar
									hora={hora}
									changeHora={changeHora}
									fechaSeleccionada={MyDate}
								/>
							);
						})}
					</div>
				);
			case 3:
				const hora = getHora();
				return (
					<>
						<h5 className="my-3">Resumen de la contratación</h5>
						<ul className="list-group mb-3">
						{empresa?.datos?.nombreEmpresa !== "Cuidatia" && (
											<>
												<li className="list-group-item"><strong>Fecha:</strong> {modHoraModal()}</li>
												<li className="list-group-item"><strong>Hora:</strong> {hora?.hora}</li>
											</>
										)}
							<li className="list-group-item"><strong>Precio:</strong> {Servicio.precioMin} €</li>
							<li className="list-group-item"><strong>Duración:</strong> {Servicio.horasMin} min</li>
						</ul>
						<div className="pt-2">
							<h6 className="mb-1 px-2" style={{ fontWeight: 600, fontSize: '0.95rem' }}>
								¿Para quién?
							</h6>
							<ul className="list-group mb-3">
								<li className="list-group-item"><strong>Nombre:</strong>  {Paciente?.nombrePaciente} {Paciente?.apellidosPaciente}</li>
								<li className="list-group-item"><strong>Localidad:</strong> {Paciente?.localidad.nombre}</li>
								<li className="list-group-item"><strong>Dirección:</strong> {Paciente?.direccionPaciente}</li>
							</ul>
						</div>
					</>
				);
			case 4:
				//setHabilitado(false)
				return clientSecret ? (
					<>
						<div
							className={`d-flex align-items-center p-2 rounded border my-3 ${metodoPago === 1 ? 'bg-light border-success' : 'bg-white'}`}
							style={{ cursor: 'pointer' }}
							onClick={() => seleccionarMetodoPago(1)}
						>
							<div className="flex-grow-1 justify-content-between d-flex">
								<div className="fw-semibold text-truncate">Saldo del monedero</div>
								<div className='text-muted fw-semibold'>{saldo}€</div>
							</div>
						</div>
						{
							saldoMessage && (
								<div className={`alert alert-danger rounded-3`} role="alert">
									{saldoMessage}
								</div>
							)
						}
						<div
							className={`d-flex align-items-center p-2 rounded border my-3 ${metodoPago === 2 ? 'bg-light border-success' : 'bg-white'}`}
							style={{ cursor: 'pointer' }}
							onClick={() => seleccionarMetodoPago(2)}
						>
							<div className="flex-grow-1">
								<div className="fw-semibold text-truncate">Pago por adelantado</div>
							</div>
						</div>
						{
							metodoPago === 2 && (
								<Elements options={{ clientSecret, paymentMethodCreation: 'manual' }} stripe={stripePromise} className='my-3'>
									<FormularioPago
										factura={factura}
										stripeMessage={stripeMessage}
										createPayment={createPayment}
										enviarYMostrarResultado={enviarYMostrarResultado}
										setActiveStep={setActiveStep}
										activeStep={activeStep}
										setHabilitado={setHabilitado}
									/>
								</Elements>
							)
						}
						
					
				</>
				) : <p>Cargando datos de pago...</p>;
			default:
				return EstadoConsulta ? (
					<p className="text-success my-3">Su compra se ha procesado correctamente. Hemos enviado un correo electrónico a su dirección con todos los detalles de la reserva. 
  						Recibirá una notificación adicional cuando el prestador confirme la solicitud. ¡Gracias por confiar en Cuidatia!</p>
				) : (
					<p className="text-danger">Ocurrió un error. Intente nuevamente.</p>
				);
		}
	};

	useEffect(() => {
		console.log('activeStep', activeStep)
	},[activeStep]);

	const handleNext = () => {
		anadiServicioLista();
		if (empresa?.datos?.nombreEmpresa === "Cuidatia") {
			switch (activeStep) {
				case 0:
					if (!Paciente?.id) return setModalSeleccionPaciente(true);
					setActiveStep(3); // Salto directo a resumen
					return;
				case 3:
					get_clientSecret();
					setActiveStep(4);
					setHabilitado(false);
					return;
				case 4:
					pagoMonedero();
					return;
				default:
					setModalAnadirServicioShareCare(false);
					setActiveStep(0);
			}
		}

		switch (activeStep) {
			case 0:
				if (!Paciente?.id) return setModalSeleccionPaciente(true);
				setActiveStep(1);
				break;
			case 1:
				getHoras();
				getHorasShareCare();
				setActiveStep(2);
				break;
			case 2:
				if (!hayHora()) return setModalSeleccionHora(true);
				setActiveStep(3);
				break;
			case 3:
				get_clientSecret();
				setActiveStep(4);
				setHabilitado(false);
				break;
			case 4:
				pagoMonedero();
				break;
			default:
				setModalAnadirServicioShareCare(false);
				setActiveStep(0);
		}
	};

	const handleBack = () => {
		if (empresa?.datos?.nombreEmpresa === "Cuidatia") {
			if (activeStep === 3) {
				setActiveStep(0);
				return;
			}
    	}

		if (activeStep === 0) {
			setModalAnadirServicioShareCare(false);
		} else {
			setActiveStep(activeStep - 1);
		}
		if(!habilitado) {
			setHabilitado(true);
		}
	};
	
	const stepsForStepper = steps.slice(0, -1);
	let stepperIndex = activeStep;

	if (empresa?.datos?.nombreEmpresa === "Cuidatia" && activeStep > 0) {
		stepperIndex = activeStep - 2;
	}

	if (stepperIndex > stepsForStepper.length - 1) {
		stepperIndex = stepsForStepper.length - 1;
	}

	return (

		<>
			<Modal show={ModalAnadirServicioShareCare} onHide={() => setModalCancelarCompra(true)} centered size="lg">
				<Modal.Header className="d-flex justify-content-between align-items-center">
					<Modal.Title className="m-0">
						{Servicio?.servicio_id?.nombre || 'Servicio'}
					</Modal.Title>
					<button type="button" className="btn-close" aria-label="Close" onClick={()=>setModalCancelarCompra(true)}></button>
				</Modal.Header>
				<Modal.Body>
					<div className='steps-modal-pefil-empresa'>
						<ProgressBar 
							now={(stepperIndex / (stepsForStepper.length - 1)) * 100} 
							variant='success' 
							className="mb-3" 
							style={{ backgroundColor: '#e6f4ef' }} 
						/>
						<Box sx={{ width: '100%' }}>
							<Stepper activeStep={stepperIndex}>
								{stepsForStepper.map((label, index) => {
									const stepProps = {};
									const labelProps = {};
									if (isStepSkipped(index)) stepProps.completed = false;

									return (
										<Step key={label} {...stepProps} className='step-perfil-empresa'>
											<StepLabel {...labelProps}>
												<div className='centrador'>{label}</div>
											</StepLabel>
										</Step>
									);
								})}
							</Stepper>
						</Box>
					</div>
					{renderStepContent()}
				</Modal.Body>
				<Modal.Footer className="d-flex justify-content-between">
					<Button variant="secondary" onClick={handleBack}>
						{activeStep === 0 ? 'Cancelar' : 'Atrás'}
					</Button>
					<Button className='login-boton' onClick={handleNext} disabled={!habilitado}>
						{activeStep === 5 ? 'Finalizar' : 'Siguiente'}
					</Button>
				</Modal.Footer>
			</Modal>

			{/* Modal confirmación de cancelación */}
			<Modal show={ModalCancelarCompra} onHide={() => setModalCancelarCompra(false)} centered>
				<Modal.Header>
					<Modal.Title>¿Cancelar servicio?</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<p>Si cancelas ahora, perderás el progreso actual.</p>
					<p>¿Estás seguro?</p>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="danger" onClick={() => {
						setModalCancelarCompra(false);
						setModalAnadirServicioShareCare(false);
						setActiveStep(0);
					}}>Cancelar compra</Button>
					<Button variant="secondary" onClick={() => setModalCancelarCompra(false)}>Volver</Button>
				</Modal.Footer>
			</Modal>

			{/* Modales auxiliares */}
			<Modal show={ModalSeleccionHora} onHide={() => setModalSeleccionHora(false)} centered>
				<Modal.Header>
					<Modal.Title>Selecciona una hora</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<p>Por favor, selecciona una hora para continuar.</p>
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={() => setModalSeleccionHora(false)}>Aceptar</Button>
				</Modal.Footer>
			</Modal>

			<Modal show={ModalSeleccionPaciente} onHide={() => setModalSeleccionPaciente(false)} centered>
				<Modal.Header>
					<Modal.Title>Selecciona un paciente</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<p>Debes seleccionar un paciente antes de continuar.</p>
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={() => setModalSeleccionPaciente(false)}>Aceptar</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
};
